import { logger } from '@heidi/runtime/logger';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { produce } from 'immer';
import type {
  GetTemplateCreationRecordResponse,
  UpdateTemplateCreationRecordRequest,
} from '../../contracts';
import {
  GET_TEMPLATE_CREATION_RECORD_BY_ID,
  UPDATE_TEMPLATE_CREATION_RECORD_KEY,
} from '../../contracts';
import { updateTemplateCreationRecord } from '../api/templates';
import { invalidateTemplateCreationRecordById } from '../invalidate';

export const useMutateUpdateTemplateCreationRecord = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [UPDATE_TEMPLATE_CREATION_RECORD_KEY],
    mutationFn: async ({
      templateCreationRecordId,
      data,
      signal,
    }: {
      templateCreationRecordId: string;
      data: UpdateTemplateCreationRecordRequest;
      signal?: AbortSignal;
    }) => {
      return await updateTemplateCreationRecord({
        templateCreationRecordId,
        data,
        signal,
      });
    },

    onMutate: ({ templateCreationRecordId, data }) => {
      queryClient.setQueryData<GetTemplateCreationRecordResponse>(
        [GET_TEMPLATE_CREATION_RECORD_BY_ID, { templateCreationRecordId }],
        (oldData) => {
          if (!oldData) {
            return undefined;
          }
          return produce(oldData, (draft) => {
            draft.template_creation_record = {
              ...draft.template_creation_record,
              ...data,
            };
          });
        }
      );
    },

    onError: (error, { templateCreationRecordId }) => {
      logger.error(error);
      void invalidateTemplateCreationRecordById(templateCreationRecordId);
    },
  });
};
